import { Zork } from "../components/zork/zork";
export class NotificationService {
    static reportIssue(sender, issue) {
        fetch("/report-issue", {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                [Zork.csrfHeader]: Zork.csrfToken
            },
            body: JSON.stringify(Object.assign({ sender }, issue))
        }).catch((error) => {
            console.error("Issue reporting failed:", error);
        });
    }
    // Пример использования для ошибки
    static reportError(sender, message) {
        this.reportIssue(sender, { type: "error", message });
    }
    // Пример использования для исключения
    static reportException(sender, exception) {
        this.reportIssue(sender, {
            type: "exception",
            message: exception.message,
            name: exception.name,
            stack: exception.stack
        });
    }
}
